export default {"src":"/_next/static/media/profile.a9b5656a.svg","height":400,"width":240,"blurWidth":0,"blurHeight":0};